import React, { useRef } from 'react';
import {
  WrapperBox,
  HeadTitleWrapper,
  GuestMainTextContainer,
  StyledColumns,
  StyledColumn,
  StyledBox,
  StyledPlaceholderCloudImage,
  StyledTextPairingOragnize,
  StyledTextPairingCommunicate,
  StyledTextPairingTrack,
} from './OverviewArt.styles';
import { SpacingStack } from '@components/SpacingStack';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { useOnScreen } from '@hooks/useOnScreen';
import { useTranslation } from 'react-i18next';

export const OverviewArt: React.FC = () => {
  const sectionId = 'Everything_Guest_At_A_Glance.';
  const { t } = useTranslation('guestList');
  const overviewArt = t('overviewArt');
  const sectionRef = useRef<HTMLDivElement>(null);
  const onScreen = useOnScreen(sectionRef, '0px');
  return (
    <WrapperBox backgroundColor="mono7" paddingY={[10]} paddingX={0} id={sectionId}>
      <HeadTitleWrapper>
        <SpacingStack spacing={[6]}>
          <Flex alignItems="center" justifyContent="center">
            <GuestMainTextContainer color="neutra6" variant="hed72Hero" tagName="h2" textAlign="center">
              {overviewArt.title}
            </GuestMainTextContainer>
          </Flex>
        </SpacingStack>
      </HeadTitleWrapper>
      <Box ref={sectionRef}>
        <StyledColumns>
          <StyledColumn>
            <StyledBox backgroundColor={'humana1Light'} paddingBottom={10}>
              <StyledPlaceholderCloudImage
                resizeWidth={550}
                mobileResizeWidth={350}
                src={overviewArt.oragnize.image}
                alt={overviewArt.oragnize.title}
                isMainSrcShown={onScreen}
                optimization="mild"
              />
              <StyledTextPairingOragnize
                alignment="center"
                title={overviewArt.oragnize.title}
                titleVariant="calloutHed32"
                titleColor="neutra6"
                titleTagName="h2"
                body={overviewArt.oragnize.body}
                bodyVariant="featureCopy17"
                bodyColor="neutra5"
                bodyTagName="p"
              />
            </StyledBox>
          </StyledColumn>
          <StyledColumn>
            <StyledBox backgroundColor={'humana1Light'} paddingBottom={10}>
              <StyledPlaceholderCloudImage
                resizeWidth={550}
                mobileResizeWidth={350}
                src={overviewArt.communicate.image}
                alt={overviewArt.communicate.title}
                isMainSrcShown={onScreen}
                optimization="mild"
              />
              <StyledTextPairingCommunicate
                alignment="center"
                title={overviewArt.communicate.title}
                titleVariant="calloutHed32"
                titleColor="neutra6"
                titleTagName="h2"
                body={overviewArt.communicate.body}
                bodyVariant="featureCopy17"
                bodyColor="neutra5"
                bodyTagName="p"
              />
            </StyledBox>
          </StyledColumn>
          <StyledColumn>
            <StyledBox backgroundColor={'humana1Light'} paddingBottom={10}>
              <StyledPlaceholderCloudImage
                resizeWidth={550}
                mobileResizeWidth={350}
                src={overviewArt.track.image}
                alt={overviewArt.track.title}
                isMainSrcShown={onScreen}
                optimization="mild"
              />
              <StyledTextPairingTrack
                alignment="center"
                title={overviewArt.track.title}
                titleVariant="calloutHed32"
                titleColor="neutra6"
                titleTagName="h2"
                body={overviewArt.track.body}
                bodyVariant="featureCopy17"
                bodyColor="neutra5"
                bodyTagName="p"
              />
            </StyledBox>
          </StyledColumn>
        </StyledColumns>
      </Box>
    </WrapperBox>
  );
};
